export default __webpack_public_path__ + "static/media/tag.e1316cee.svg";